import React from 'react';

export function SectionCard({ title, action, children, className = '' }) {
  return (
    <div className={`bg-white border border-slate-200 rounded-xl p-4 ${className}`}>
      {(title || action) && (
        <div className="flex items-center justify-between mb-3">
          {title && <p className="text-[13px] font-semibold text-slate-800">{title}</p>}
          {action && <div className="flex items-center">{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
}

export default SectionCard;
